export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
// export const SERVER_URL = "https://rentdigicare.ca/api";
// export const SERVER_URL = "http://localhost:9000";
export const BUCKET_URL = process.env.REACT_APP_DO_SPACES_ENDPOINT;
